/* eslint-disable import/prefer-default-export */
import { createSelectorCreator, defaultMemoize } from 'reselect';
import _ from 'lodash';

const selectAppPCS = state => state.app.pcs;

const createDeepEqualSelector = createSelectorCreator(defaultMemoize, _.isEqual);

export const makeSelectAppPCS = createDeepEqualSelector(selectAppPCS, pcs => pcs);
